import React, { useState, useContext } from "react";
import PropTypes from "prop-types";
import { Card, Form, Nav, ProgressBar } from "react-bootstrap";
import { useForm } from "react-hook-form";
import WizardModal from "../../common/wizard/WizardModal";
import AppContext, {
  AuthWizardContext,
  PublishAppContext,
} from "../../../context/Context";
import classNames from "classnames";
import IconButton from "../../common/IconButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Flex from "../../common/Flex";
import AccountInformation from "./AccountInformation";
import ApplicationInformation from "./ApplicationInformation";
import MarketPlaceListing from "./MarketPlaceListing";
import FinalPublish from "./FinalPublish";
import apiCall from "../../../services/apiCall";
import { toast } from "react-toastify";

const Publish = ({ variant, validation, progressBar }) => {
  const { isRTL } = useContext(AppContext);
  const { user, setUser, step, setStep } = useContext(AuthWizardContext);
  const { partnerDetails, setPartnerDetails } = useContext(PublishAppContext);

  const {
    selectedApplication,
    setMarketPlaceListingValues,
    isEditMode,onlyOneTimeFill, setOnlyOneTimeFill
  } = useContext(PublishAppContext);

  const {
    register,
    handleSubmit,
    errors,
    setError,
    setValue,
    clearErrors,
    watch,
  } = useForm();

  const [modal, setModal] = useState(false);

  const navItems = [
    {
      icon: "lock",
      label: "Application",
    },
    {
      icon: "user",
      label: "Marketplace Listing",
    },
    {
      icon: "thumbs-up",
      label: "Publish",
    },
  ];

  const onSubmitData = (data) => {
    setUser({ ...user, ...data });
    setStep(step + 1);
    
  };
  const onError = () => {
    if (!validation) {
      clearErrors();
      setStep(step + 1);
    }
  };

  const toggle = () => setModal(!modal);
  const handleNavs = () => {
    let targetStep = 3;
    if (step !== 3) {
      if (targetStep < step) {
        setStep(targetStep);
      } else {
        // handleSubmit(onSubmitData, onError)();
        setStep(step + 1);
      }
    } else {
      toggle();
    }
  };
 const handleNext = () => {
  if (!selectedApplication) {
    toast.error("⚠️ Please select an application first.");
    return;
  }

  let apiParam = {
    appId: selectedApplication.app_id,
    appName: selectedApplication.app_name,
  };

  apiCall
    .servertrip("GET", "billingconfigcheck", user, apiParam)
    .then(
      (response) => {
         if (!response) {
      toast.error("Unexpected response from server.");
      return;
    }
       if(response && response.data.message==="Billing is config."){
        toast.success("Billing check passed!");
      setStep((prev) => prev + 1);
      }
      },
      (error) => {
        const errData = error.response?.data;
        if (errData?.errorCode === "NO_BILLING") 
        {
          toast.error("Billing is not configured for the selected application.");
          return;
        }
        const resMessage =
          error.response?.data?.message ||
          error.message ||
          error.toString();
        toast.error(resMessage);
      }
    );
};


  return (
    
    <>
      <WizardModal modal={modal} setModal={setModal} />
      <Card className="theme-wizard mb-5">
        <Card.Header
          className={classNames("bg-light", {
            "px-4 py-3": variant === "pills",
            "pb-2": !variant,
          })}
        >
          <Nav className="justify-content-center" variant={variant}>
            {variant === "pills"
              ? navItems.map((item, index) => (
                  <NavItemPill
                    key={item.label}
                    index={index + 1}
                    step={step}
                    handleNavs={handleNavs}
                    icon={item.icon}
                    label={item.label}
                  />
                ))
              : navItems.map((item, index) => (
                  <NavItem
                    key={item.label}
                    index={index + 1}
                    step={step}
                    handleNavs={handleNavs}
                    icon={item.icon}
                    label={item.label}
                  />
                ))}
          </Nav>
        </Card.Header>
        {progressBar && <ProgressBar now={step * 25} style={{ height: 2 }} />}
        <Card.Body className="fw-normal p-3">
          {step === 1 && (
            <>
              <AccountInformation partnerDetails=
              {partnerDetails} setPartnerDetails= {setPartnerDetails}/>
              <ApplicationInformation />
            </>
          )}
          {step === 2 && (
            <div>
              <MarketPlaceListing step={step} setStep={setStep} partnerDetails=
              {partnerDetails} setPartnerDetails= {setPartnerDetails}/>
            </div>
          )}

          {step === 3 && (
            <div>
              <FinalPublish />
            </div>
          )}
        </Card.Body>
        <Form onSubmit={handleSubmit(onSubmitData)}>
        {step !== 2 && ( 
          <Card.Footer className="px-md-6 bg-light d-flex justify-content-end">
          {step > 1 && (
            <IconButton
              variant="primary"
              icon={isRTL ? "chevron-right" : "chevron-left"}
              iconAlign="left"
              size="sm"
              transform="down-1 shrink-4"
              className="px-5 mr-3 fw-semi-bold"
              onClick={() => {
                if (step === 3 && isEditMode) {
                  setOnlyOneTimeFill(false);
                }
                if (step === 1 && isEditMode) {
                  setOnlyOneTimeFill(true);
                }
                setStep(step - 1);
              }}
            >
              Prev
            </IconButton>
      )}
          {step < 3 && (
            <IconButton
              variant="primary"
              disabled={!selectedApplication}
              className="ms-auto px-5"
              size="sm"
              icon={isRTL ? "chevron-left" : "chevron-right"}
              iconAlign="right"
              transform="down-1 shrink-4"
              onClick={handleNext}
            >
              {isEditMode ? "Update" : "Next"}
            </IconButton>
          )}
    </Card.Footer>
  )}
      </Form>
        {/* <MarketPlaceListing step={step} setStep={setStep} /> */}
      </Card>
    </>
  );
};

export const NavItem = ({ index, step, handleNavs, icon, label }) => {
  return (
    <Nav.Item>
      <Nav.Link
        className={classNames("fw-semi-bold", {
          done: index < 3 ? step > index : step > 2,
          active: step === index,
        })}
        style={{ cursor: "default" }}
        // onClick={() => handleNavs(index)}
      >
        <span className="nav-item-circle-parent">
          <span className="nav-item-circle">
            <FontAwesomeIcon icon={icon} />
          </span>
        </span>
        <span className="d-none d-md-block mt-1 fs--1">{label}</span>
      </Nav.Link>
    </Nav.Item>
  );
};

export const NavItemPill = ({ index, step, handleNavs, icon, label }) => {
  return (
    <Nav.Item>
      <Nav.Link
        className={classNames("fw-semi-bold", {
          done: step > index,
          active: step === index,
        })}
        onClick={() => {
          if (handleNavs) {
            handleNavs(index)
          }
        }}
      >
        <Flex alignItems="center" justifyContent="center">
          <FontAwesomeIcon icon={icon} />
          <span className="d-none d-md-block mt-1 fs--1 ms-2">{label}</span>
        </Flex>
      </Nav.Link>
    </Nav.Item>
  );
};

Publish.propTypes = {
  variant: PropTypes.oneOf(["pills"]),
  validation: PropTypes.bool,
  progressBar: PropTypes.bool,
};

NavItemPill.propTypes = {
  index: PropTypes.number.isRequired,
  step: PropTypes.number.isRequired,
  handleNavs: PropTypes.func.isRequired,
  icon: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

NavItem.propTypes = NavItemPill.propTypes;

export default Publish;
